module.exports = __webpack_public_path__ + "static/img/08.b0020cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/08.png
// module id = eXz7
// module chunks = 1